import { useIntl } from 'react-intl';
import type { CSSProperties } from 'styled-components';
import styled from 'styled-components';

import type { Rarity } from '#src/__generated__/globalTypes.ts';
import { getRarityColor } from '#src/lib/colors.ts';
import { scarcityMessages } from '#src/lib/scarcity.ts';

const Root = styled.span`
  color: var(--text-color);
  font-weight: var(--t-bold);
`;

type Props = { scarcity: Rarity };

export const ScarcityLabel = ({ scarcity }: Props) => {
  const { formatMessage } = useIntl();

  const label = formatMessage(scarcityMessages[scarcity]);

  return (
    <Root style={{ '--text-color': getRarityColor(scarcity) } as CSSProperties}>
      {label}
    </Root>
  );
};
